import { render, staticRenderFns } from "./IndicatorInfo.vue?vue&type=template&id=43af40a4&"
import script from "./IndicatorInfo.vue?vue&type=script&lang=js&"
export * from "./IndicatorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports